import { usePostHog } from "posthog-js/react";
import type { ProductEvent } from "@onsemble/shared";
import { useLocation } from "wouter";
import { useOrganization } from "@clerk/clerk-react";

interface UseProductEventOptions {
  component?: string;
}

export const useProductEvents = (options: UseProductEventOptions = {}) => {
  const posthog = usePostHog();
  const [location] = useLocation();
  const { organization } = useOrganization();

  const capture = (event: ProductEvent) => {
    const properties = {
      ...event.context,
      view: location,
      ...options,
      orgId: organization?.id,
    };
    console.debug(
      `Product event: ${event.event}: ${JSON.stringify(properties, null, 2)}`,
    );
    posthog.capture(event.event, properties);
  };
  return { capture };
};
